export default __webpack_public_path__ + "static/media/Lato-Black.03502869.ttf";